$.basket = {
	template: {
		dayOption: function() {
			objDay = $(document.createElement('select'))
				.addClass('form-control ticketBirthdayDay');

			for (i=1; i <= 31; i++) {
				$(document.createElement('option'))
				.attr('value', i)
				.html(i)
				.appendTo(objDay);
			}

			return objDay
		},

		monthOption: function() {
			objDay = $(document.createElement('select'))
				.addClass('form-control ticketBirthdayMonth');

			var mounth = [];

			mounth[0] = 'Januar';
			mounth[1] = 'Februar';
			mounth[2] = 'Marts';
			mounth[3] = 'April';
			mounth[4] = 'Maj';
			mounth[5] = 'Juni';
			mounth[6] = 'Juli';
			mounth[7] = 'August';
			mounth[8] = 'September';
			mounth[9] = 'Oktober';
			mounth[10] = 'November';
			mounth[11] = 'December';

			for (i=1; i <= 12; i++) {
				$(document.createElement('option'))
				.attr('value', i)
				.html(mounth[(i-1)])
				.appendTo(objDay);
			}

			return objDay
		},

		yearOption: function() {
			var d = new Date();
			var n = (d.getFullYear() - 5);

			objDay = $(document.createElement('select'))
				.addClass('form-control ticketBirthdayYear');

			for (i=n; i >= 1950; i--) {
				$(document.createElement('option'))
				.attr('value', i)
				.html(i)
				.appendTo(objDay);
			}

			return objDay
		}
	},

	callback: {
		getTicketList: {
			success: function(data) {
				$.each(data.tickets, function(index, value) {
					var i = value.amount;

					$(document.createElement('strong'))
					.html('Billet type: '+ value.title)
					.appendTo('#ticketCPR');

					for(l = 0; l < i; l++) {
						$(document.createElement('div'))
						.addClass('row')
						.append(
							$(document.createElement('div'))
							.addClass('col-md-5')
							.append(
								$(document.createElement('label'))
								.html('Navn på gæst & fødselsdato')
							)
							.append(
								$(document.createElement('input'))
								.addClass('form-control ticketFullname')
							)
						)
						.append(
							$(document.createElement('div'))
							.addClass('col-md-2')
							.append(
								$(document.createElement('label'))
								.html('Dag')
							)
							.append($.basket.template.dayOption())
						)
						.append(
							$(document.createElement('div'))
							.addClass('col-md-2')
							.append(
								$(document.createElement('label'))
								.html('Måned')
							)
							.append($.basket.template.monthOption())
						)
						.append(
							$(document.createElement('div'))
							.addClass('col-md-3')
							.append(
								$(document.createElement('label'))
								.html('År')
							)
							.append($.basket.template.yearOption())
							.append('<br />')
						)
						.appendTo('#ticketCPR');
					}
				});
			}
		}
	},

	change: {
		ticketType: function(ticketType) {
			if(ticketType == 'paper') {
				$('#ticketDeliveryInfo').show();
				$('#ticketCPR').html('');
			} else if (ticketType == 'cpr') {
				$('#ticketDeliveryInfo').hide();

				$('#dialogToolbar').ajax_callback('/json/basket/ticket/getTicketList', {
				}, {
					alertToolbar: false,
					callback_success: $.basket.callback.getTicketList.success
				});
			} else {
				$('#ticketDeliveryInfo').hide();
				$('#ticketCPR').html('');
			}
		},

		admfee: function(value) {
			var subtotal = parseInt($('#tmpTotalPayment').val());
			var ticketFee = parseInt($('#tmpTicketFee').val());

			switch (value) {
				case 'creditcard':
					var mpfee = 0;
					var feestring = numeral(ticketFee).divide(100).format('0,0.00');

					$('#admfee').html(feestring + ' DKK');
					break;

				case 'mobilepay':
					var mpfee = parseInt($('#tmpMPFee').val());
					var feestring = numeral((ticketFee + mpfee)).divide(100).format('0,0.00');

					$('#admfee').html( feestring + ' DKK');
					break;
			}

			var totalpaymentstring = numeral((subtotal + ticketFee + mpfee)).divide(100).format('0,0.00');
			$('#totalprice').html(totalpaymentstring + ' DKK');
		}
	},

	push: {
		confirmOrder: function() {
			var ticketFullname = [];
			var ticketBirthdayDay = [];
			var ticketBirthdayMonth = [];
			var ticketBirthdayYear = [];

			var i = 0
			$.each($('.ticketFullname'), function(index, value){
				ticketFullname[i] = value.value;
				i++
			});

			var i = 0
			$.each($('.ticketBirthdayDay'), function(index, value){
				ticketBirthdayDay[i] = value.value;
				i++
			});

			var i = 0
			$.each($('.ticketBirthdayMonth'), function(index, value){
				ticketBirthdayMonth[i] = value.value;
				i++
			});

			var i = 0
			$.each($('.ticketBirthdayYear'), function(index, value){
				ticketBirthdayYear[i] = value.value;
				i++
			});

			$.post( '/json/basket/confirmOrder', {
				'dynamicField1' : $('#dynamicField1').val(),
				'customerName' : $('#customerName').val(),
				'customerEmail' : $('#customerEmail').val(),
				'customerPhone' : $('#customerPhone').val(),
				'customerStreet' : $('#customerStreet').val(),
				'customerZipcode' : $('#customerZipcode').val(),
				'customerCity' : $('#customerCity').val(),
				'agreeTheConditions' : $('#agreeTheConditions:checked').val(),
				'ticketType' : $('#ticketType').val(),
				'payment' : $('.payment:checked').val(),
				'ticketFullname' : ticketFullname,
				'ticketBirthdayDay' : ticketBirthdayDay,
				'ticketBirthdayMonth' : ticketBirthdayMonth,
				'ticketBirthdayYear' : ticketBirthdayYear,
			}, function(data) {
				if(data.status == 200) {
					paymentwindow = new PaymentWindow({
						'merchantnumber': data.gateway.merchantnumber,
						'amount': data.gateway.amount,
						'orderid': data.gateway.orderid,
						'paymentcollection': data.gateway.paymentcollection,
						'lockpaymentcollection': data.gateway.lockpaymentcollection,
						'currency': data.gateway.currency,
						'paymenttype': data.gateway.paymenttype,
						'callbackurl': data.gateway.callbackurl,
						'accepturl': data.gateway.accepturl,
						'ownreceipt': data.gateway.ownreceipt,
						'hash': data.gateway.hash
					});
					paymentwindow.open();
				} else {
					alertToolBar(data.error.header,data.error.msg, 'error')
				}
			},'json');
		}
	}
};
